export const orangeColor = "#E18762";
export const secondColor = "#CFA01C";
export const greyColor = "#6F736D";
